import * as React from 'react';
import { IntlProvider } from 'react-intl';

import { useQuery } from '@apollo/client';

import { ReactFCC } from '@notino/react-styleguide';
import {
  GetLocalesDataQuery,
  GetLocalesDataQueryVariables,
} from '@notino/shared/definitions/types';

import * as Sentry from '@sentry/browser';

import { IntlProviderOverride } from './IntlProviderOverride';
import getLocalesQuery from './queries/localesData.graphql';
import { usePrefixes } from './usePrefixes';
interface ILanguageProviderProps {
  originUrl: string;
}

export const LanguageProvider: ReactFCC<ILanguageProviderProps> = ({
  children,
  originUrl,
}) => {
  const prefixes = usePrefixes(originUrl);

  const { data, error, previousData } = useQuery<
    GetLocalesDataQuery,
    GetLocalesDataQueryVariables
  >(getLocalesQuery, {
    variables: {
      prefixes: prefixes,
    },

    skip: prefixes === null,
  });

  const languageData = data || previousData;

  if (!languageData?.languagedMessagesByPrefixes || error) {
    return null;
  }

  const locale = languageData?.languagedMessagesByPrefixes?.acceptLanguage;
  const messages = languageData?.languagedMessagesByPrefixes?.messages;

  return (
    <IntlProvider
      locale={locale}
      key={locale}
      messages={messages}
      onError={Sentry.captureException}
    >
      <IntlProviderOverride>
        {React.Children.only(children)}
      </IntlProviderOverride>
    </IntlProvider>
  );
};
